export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15021.f883610d.jpg";